<template>
  <el-dialog
    title="临时登录申请"
    :visible.sync="dialogVisible"
    :modal="false"
    :close-on-click-modal="false"
    width="400px"
  >
    <div class="display-flex mb10">
      <span class="apply-label">用户名</span>
      <el-input
        v-model="dialogObj.account"
        class="apply-value"
        @blur="checkAccount"
        placeholder="请输入核心系统的登录用户名"
        size="mini"
      ></el-input>
    </div>
    <!-- <div class="display-flex mb10">
      <span class="apply-label">密码</span>
      <el-input
        v-model="dialogObj.password"
        class="apply-value"
        placeholder="请输入核心系统的登录密码"
        size="mini"
      ></el-input>
    </div> -->
    <div class="display-flex mb10">
      <span class="apply-label">申请时间</span>
      <el-select v-model="dialogObj.申请时间" class="apply-value" filterable size="mini" placeholder="请选择">
        <el-option v-for="item in duration" :key="item" :label="`${item}小时`" :value="item"> </el-option>
      </el-select>
    </div>
    <p class="apply-alert">临时登录的申请使用时间（审核通过后开始计时）</p>
    <div class="display-flex mb10">
      <span class="apply-label">申请附件</span>
      <div class="apply-value">
        <el-button type="text" size="mini" @click="showDialog('附件')">上传附件</el-button>
        <div class="file-box">
          <p class="file-name mb5" v-for="file in dialogObj.附件" :key="file.md5" @click="preview(file)">
            {{ file.originalname }}
          </p>
        </div>
      </div>
    </div>
    <p class="apply-alert">请上传相关负责人同意申请的附件，如：聊天截图等</p>
    <div class="display-flex mb10"><span class="apply-label">申请原因</span></div>
    <el-input
      :rows="2"
      v-model="dialogObj.申请原因"
      :autosize="{ minRows: 2, maxRows: 8 }"
      type="textarea"
      placeholder="请输入申请原因"
    />

    <span slot="footer" v-if="uploading === 0" class="dialog-footer">
      <div
        class="radish-btn radish-btn-primary radish-btn-small"
        style="width: 100%;text-align: center;"
        @click="confirm"
      >
        确 定
      </div>
    </span>

    <UploadDialog
      ref="UploadDialog"
      url="publicUploads"
      type="附件"
      :on-progress="uploadProgress"
      :on-success="uploadSuccess"
      :on-error="uploadError"
    />
    <PublicPreview style="top: 0;" ref="PublicPreview" width="40%"></PublicPreview>
  </el-dialog>
</template>
<script>
import { PublicPreview } from '../../file'

// 时间选项，1-12小时可选
const duration = []
for (let i = 1; i < 13; i++) {
  duration.push(i)
}
export default {
  components: { PublicPreview },
  data() {
    return {
      dialogVisible: false,
      dialogObj: {},
      duration: duration,
      uploading: 0,
    }
  },
  methods: {
    async open() {
      this.dialogVisible = true
      this.dialogObj = {}
      this.$refs.UploadDialog && this.$refs.UploadDialog.clean()
    },
    showDialog() {
      this.$refs.UploadDialog && this.$refs.UploadDialog.visible(true)
    },
    async preview(file) {
      const ref = this.$refs.PublicPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    uploadProgress() {
      this.uploading += 1
    },
    async uploadSuccess(response, file, fileList) {
      this.uploading -= 1
      this.$refs.UploadDialog.visible()
      const res = response[0]
      try {
        if (!this.dialogObj.附件) this.$set(this.dialogObj, '附件', [])
        this.dialogObj.附件.push(res)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    async uploadError(res) {
      this.uploading -= 1
    },
    async checkAccount() {
      if (!this.dialogObj.account) return this.$message.error('请填写账号')
      const res = await app.service('fingerPrint').checkAccount(this.dialogObj.account)
      if (res.status === 'success') {
        this.user = res.data
        if (!this.user) return this.$message.error(`该账号不存在，请重新确认`)
        if (this.user.状态 === '已离职') return this.$message.error(`该账号已离职，无法申请`)
      } else this.$message.error(res.msg)
    },
    async confirm() {
      const checkField = [
        { field: 'account', label: '用户名' },
        { field: '申请时间', label: '申请时间' },
        { field: '附件', label: '附件' },
        { field: '申请原因', label: '申请原因' },
      ]
      for (let val of checkField) {
        if (!this.dialogObj[val.field]) return this.$message.error(`请完善${val.label}`)
        else if (Array.isArray(this.dialogObj[val.field]) && this.dialogObj[val.field].length === 0) {
          return this.$message.error(`请完善${val.label}`)
        }
      }

      if (!this.user) return this.$message.error(`该账号不存在，请重新确认`)
      if (this.user.状态 === '已离职') return this.$message.error(`该账号已离职，无法申请`)
      // const res = await app.service('misc').applyForTempLogin(this.dialogObj)
      const res = await app.service('fingerPrint').applyForTempLogin(this.dialogObj)

      if (res.status === 'success') {
        this.$message.success('已提交，请等待管理员审核')
        this.dialogVisible = false
      } else this.$message.error(res.msg)
    },
  },
}
</script>
<style scoped>
.display-flex {
  display: flex;
  align-items: center;
}
.apply-label {
  width: 80px;
  flex: none;
  align-self: baseline;
  margin-top: 5px;
}
.apply-value {
  flex: auto;
}
.apply-alert {
  color: #b1b1b1;
}
.mb5 {
  margin-bottom: 5px;
}
.mb10 {
  margin-bottom: 10px;
}
.file-box {
  display: flex;
  flex-direction: column;
}
.file-name {
  color: #409eff;
  cursor: pointer;
}
</style>
